import { render, staticRenderFns } from "./Celebrity.vue?vue&type=template&id=7ba1c442&scoped=true"
import script from "./Celebrity.vue?vue&type=script&lang=js"
export * from "./Celebrity.vue?vue&type=script&lang=js"
import style0 from "./Celebrity.vue?vue&type=style&index=0&id=7ba1c442&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1c442",
  null
  
)

export default component.exports